var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBlogicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 129,
    viewBox: "0 0 213 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.213 125.627C120.847 123.429 119.242 124.959 120.634 122.609C123.538 117.709 127.395 109.101 132.578 106.444C138.794 103.256 145.685 101.16 152.729 101.16C157.538 101.16 162.346 101.16 167.155 101.16C175.321 101.16 183.216 102.259 191.288 103.347C194.944 103.84 198.549 103.814 202.224 103.814",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.619 34.8115C133.126 27.7421 143.956 29.748 157.308 29.853C168.32 29.9396 179.257 31.0636 190.263 31.0636C191.295 31.0636 198.25 31.9682 198.25 30.2565",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.49 31.0195C195.49 38.67 193.819 43.5571 193.819 51.22C193.819 55.7506 194.846 59.709 195.49 64.1465C195.98 67.5164 195.589 71.2167 195.589 74.6155C195.589 77.8943 196.916 80.8215 196.916 84.1015C196.916 86.4784 197.3 88.6858 197.358 91.0809C197.415 93.426 199.128 95.2429 199.128 97.6179C199.128 98.6591 198.614 102.006 199.57 102.484",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.484 34.8047C121.484 41.8577 121.991 49.1383 121.042 56.1359C119.311 68.9009 121.031 82.2054 120.501 95.063C120.149 103.605 118.44 112.024 118.388 120.572C118.375 122.639 118.517 124.749 118.388 126.814C118.355 127.332 117.972 126.786 117.847 126.617C116.213 124.42 114.939 121.938 113.546 119.589C110.643 114.689 107.399 109.099 102.217 106.441C96.001 103.253 89.1102 101.158 82.0656 101.158C77.257 101.158 72.4485 101.158 67.64 101.158C59.4738 101.158 51.5789 102.256 43.5072 103.345C39.8507 103.838 36.2457 103.812 32.5712 103.812",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.927 35.6885C110.419 27.9386 96.1552 28.0534 82.8031 28.1685C71.7911 28.2634 60.854 29.4955 49.8479 29.4955C48.8161 29.4955 41.8609 30.4872 41.8609 28.6108",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8604 28.6094C41.8604 36.2599 40.9756 43.5557 40.9756 51.2185C40.9756 55.7491 39.9487 59.7075 39.3045 64.145C38.8154 67.5149 39.2062 71.2152 39.2062 74.614C39.2062 77.8928 37.8792 80.82 37.8792 84.1001C37.8792 86.477 37.4952 88.6843 37.4368 91.0794C37.3796 93.4245 35.6674 95.2414 35.6674 97.6164C35.6674 98.6576 36.1808 102.004 35.2251 102.482",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3947 105.207C37.7503 109.717 36.4647 114.032 35.4908 118.459C35.4333 118.721 34.9884 119.608 35.3588 119.357C37.11 118.169 39.065 117.55 40.9818 116.664C45.8857 114.399 50.7868 113.725 56.082 112.968C62.4253 112.062 69.3314 112.357 75.6965 112.81C82.5945 113.301 88.9617 114.919 95.4166 117.324C99.6865 118.915 103.863 120.556 108.062 122.314C110.275 123.24 112.201 124.562 114.635 124.927C116.156 125.155 117.648 125.165 119.176 125.165",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.015 105.672C191.583 110.182 192.716 114.497 193.574 118.924C193.625 119.186 194.017 120.073 193.691 119.822C192.147 118.633 190.424 118.015 188.734 117.129C184.411 114.863 180.091 114.19 175.424 113.433C169.832 112.527 163.745 112.822 158.134 113.275C152.053 113.766 146.441 115.384 140.751 117.789C136.987 119.38 133.306 121.021 129.604 122.778C127.654 123.705 125.956 125.027 123.81 125.392C122.47 125.62 121.154 125.63 119.808 125.63",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.043 46.2035C49.4384 43.8071 51.7739 41.7647 54.5821 41.3122C55.9217 41.0964 57.2887 41.0078 58.6442 41.0078C59.7101 41.0078 60.6104 40.9957 61.6146 41.4172C65.1316 42.8935 68.5173 44.7569 72.1739 45.8781C73.7822 46.3713 75.3351 46.6061 77.0022 46.7913C78.2583 46.9309 79.2914 47.0208 80.5184 46.6024C82.2564 46.0096 83.683 44.737 85.4517 44.1987C86.2547 43.9543 87.3022 43.6733 88.1597 43.8838C88.9574 44.0796 89.6798 44.5822 90.4059 44.9439C91.2578 45.3683 92.1322 45.6755 93.051 45.9201C95.2062 46.4938 97.4297 46.859 99.6531 47.0327C100.277 47.0815 100.923 47.0965 101.228 46.4869",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4717 65.9408C57.1257 64.2347 60.1769 63.6937 63.2372 63.1813C66.1897 62.6869 69.0884 61.9056 72.0929 61.8827C72.6855 61.8782 73.7301 61.7183 74.2753 61.9909C74.9239 62.3152 75.487 62.9605 76.0609 63.3977C77.5355 64.5212 79.0635 65.3854 80.7683 66.1031C86.7845 68.6363 93.5354 68.6757 99.9767 68.3577C101.176 68.2984 102.749 67.9186 103.557 66.9238C103.791 66.6355 103.915 66.2655 104.305 66.2655",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M139.691 53.438C141.15 52.6983 142.606 51.9442 144.029 51.1384C145.96 50.045 147.748 49.3428 149.828 48.6494C151.379 48.1322 153.266 47.836 154.905 48.1895C156.945 48.6295 158.939 49.2825 160.992 49.7045C162.349 49.9834 163.709 50.1514 165.086 50.2997C166.978 50.5034 168.983 50.8908 170.894 50.8047C172.138 50.7487 173.363 49.7045 174.591 49.7045",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.827 70.4813C150.419 70.1506 159.968 69.832 169.568 69.832C172.054 69.832 174.54 69.832 177.026 69.832",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.703 78.4375H166.637",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17969 36.2005C4.99949 36.2005 7.7076 35.947 10.5022 35.581C12.4548 35.3253 14.5091 34.7461 16.4815 34.7461",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7549 14.8672C17.1816 15.5945 18.521 16.8207 20.1181 17.0488",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6928 1.53516C33.6928 4.15734 33.208 6.69864 33.208 9.29206",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.164 5.41406C188.922 7.14113 190.239 8.88799 191.365 10.416C192.051 11.3473 192.07 12.6169 193.366 12.6169",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206.171 15.4183C207.67 14.4192 209.204 13.0595 210.973 12.6172",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M203.771 25.7461C205.683 26.4576 207.124 26.6982 208.572 28.147",
    stroke: "#FB7C51",
    strokeWidth: 2.50495,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBlogicon);
export default __webpack_public_path__ + "static/media/noBlogicon.b0a08fb30beb08c43d6c43e175185745.svg";
export { ForwardRef as ReactComponent };